import React from 'react'
import 'project/polyfill'
import { ItemListElements } from 'next-seo/lib/types'
import { I18NConfig } from 'next/dist/server/config-shared'

import SeoContainer, {
  SeoContainerProps,
} from 'components/util/containers/SeoContainer'
import { Utils } from 'common/utils'
import Strings from 'project/localisation'
import { getPlans } from 'common/planData'
import { createClient } from '../../prismicio'
import OurAddress from 'components/OurAddress'
import { TPlanSummary } from 'common/cms-types'
import HoxtonMixLogo from 'components/icons/HoxtonMixLogo'
import useWindowSize from 'components/util/useWindowSize'
import PartnerHeroBanner from 'components/hero/PartnerHeroBanner'
import { NextPageWithLayout } from '../../types/nextPageWithLayout'
import { contactUsStrings } from 'common/strings/contact-us-strings'
import PageContainer from 'components/util/containers/PageContainer'
import { auHomeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import { Tenant } from 'common/tenant'

export type PageType = {
  plans: TPlanSummary[]
}

const Page: NextPageWithLayout<PageType> = ({ plans }) => {
  const seoProps: SeoContainerProps['seoProps'] = {
    description:
      'Reach our Sydney team via phone, email or live chat. The Hoxton Mix Australia is here to support you with business address services and integration help.',
    openGraph: {
      url: 'https://www.hoxtonmix.com/au/contact-us/',
    },
    title: 'Contact The Hoxton Mix Australia',
  }
  const breadcrumb: ItemListElements[] = [
    auHomeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/au/contact-us/',
      name: `${Strings.contactUs}`,
      position: 2,
    },
  ]
  const size = useWindowSize()

  return (
    <SeoContainer
      alternate={[
        { href: '/contact-us', lang: 'en-gb' },
        { href: '/au/contact-us', lang: 'en-au' },
      ]}
      breadcrumb={breadcrumb}
      seoProps={seoProps}
    >
      <main className='overflow-x-hidden new-design d-flex flex-column'>
        <PartnerHeroBanner
          partnershipLogo={
            <HoxtonMixLogo
              className='mb-6 mb-lg-4 max-w-100'
              width={774}
              height={92}
            />
          }
          title={contactUsStrings.wedLoveToHearFromYou}
          robotImage={{
            height: 1031,
            src: '/images/new/au/robot-holding-mail.png',
            width: 800,
          }}
          imageContainerWidth={size.isLgOrHigher ? '48%' : '100%'}
          description={
            <div className='lh-114 fs-fluid-18-26'>
              <span>{contactUsStrings.wedLoveToHearFromYouDescription}</span>
              <p
                className='mt-5'
                dangerouslySetInnerHTML={{
                  __html: contactUsStrings.contactInstructionsAu,
                }}
              />
              <OurAddress
                className='color-pink2 fw-semibold'
                tenant={Tenant.AU}
              />
            </div>
          }
        />
      </main>
    </SeoContainer>
  )
}
Page.getLayout = (page: React.ReactNode) => (
  <PageContainer tenant={Tenant.AU}>{page}</PageContainer>
)
export async function getStaticProps(
  context: I18NConfig & { locale?: string; params: { uid: string } },
) {
  try {
    const client = createClient(context)
    const lang = Utils.getLocaleID(context.locale || context.defaultLocale)
    const plans = await getPlans(undefined, String(Tenant.AU))
    return {
      props: {
        plans,
      },
    }
  } catch (e) {
    console.log(e)
    return {
      props: {},
    }
  }
}
export default Page
